import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ButtonWithIcon } from '@els/els-react--button';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import ResultHitNavigation from '@Components/Results/common/ResultHitNavigation';

import './SubstanceFactLinks.scss';

function isMoreNamesAvailable(substance) {
  const isChemicalNames = getValueByNs({ substance }, 'substance.details.chemicalNames.length', false);
  const isChemicalNameSynonyms = getValueByNs({ substance }, 'substance.details.chemicalNameSynonyms.length', false);

  return isChemicalNames && isChemicalNameSynonyms;
}

function SubstanceAlternativeDetails({ toggleSuppliers, toggleIdentification, toggleMoreNames = () => null, openStates = {}, substance }) {
  const { supplierData } = substance;
  const resultIdentifier = substance.index ?? substance.id;
  const ariaLabel =
    resultIdentifier !== undefined && resultIdentifier !== null
      ? `Substance result ${resultIdentifier} details`
      : 'Substance result details';
  const links = [
    {
      id: 'identification',
      dataE2E: 'substance-identification-link',
      label: 'Identification',
      onToggle: toggleIdentification,
      isOpen: !!openStates?.identification,
      className: 'identification',
      isVisible: true,
    },
    {
      id: 'supplierInformation',
      dataE2E: 'substance-supplier-information-link',
      label: 'Supplier Information',
      onToggle: toggleSuppliers,
      isOpen: !!openStates?.supplierInformation,
      className: 'supplier-information',
      isVisible: !!supplierData,
    },
    {
      id: 'moreNames',
      dataE2E: 'substance-more-names-link',
      label: 'More names',
      onToggle: toggleMoreNames,
      isOpen: !!openStates?.moreNames,
      className: 'more-names',
      isVisible: isMoreNamesAvailable(substance),
    },
  ].filter(({ isVisible }) => isVisible);

  if (!links.length) {
    return null;
  }

  return (
    <ResultHitNavigation ariaLabel={ariaLabel}>
      <ul className="substance-fact-links substance-alternative-fact-links">
        {links.map(({ id, dataE2E, label, onToggle, isOpen }) => (
          <li
            className={classnames('substance-fact-links__item', { 'substance-fact-links__item--active': isOpen })}
            key={id}
            data-e2e={dataE2E}>
            <ButtonWithIcon
              data-e2e={dataE2E}
              className="substance-fact-links__accordion"
              type="link"
              size="small"
              iconRight
              sprite={isOpen ? 'ChevronUp' : 'ChevronDown'}
              aria-expanded={isOpen}
              onClick={(event) => {
                event.preventDefault();
                onToggle();
              }}>
              {label}
            </ButtonWithIcon>
          </li>
        ))}
      </ul>
    </ResultHitNavigation>
  );
}

SubstanceAlternativeDetails.propTypes = {
  toggleSuppliers: PropTypes.func.isRequired,
  toggleIdentification: PropTypes.func.isRequired,
  substance: PropTypes.object.isRequired,
  toggleMoreNames: PropTypes.func,
  openStates: PropTypes.shape({
    identification: PropTypes.bool,
    supplierInformation: PropTypes.bool,
    moreNames: PropTypes.bool,
  }),
};

export default SubstanceAlternativeDetails;
